// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"796":"ecf00f39","6743":"54fcdcb9","9023":"ecf00f39","9938":"ecf00f39"}[chunkId] + ".css";
};